import { render, staticRenderFns } from "./generalChart.vue?vue&type=template&id=32ff3aaa"
import script from "./generalChart.vue?vue&type=script&lang=js"
export * from "./generalChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports